import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.prefecture.loading;
export const prefectureErrorMessage = (state: RootState) =>
  state.prefecture.error;
export const prefectureDataResponse = (state: RootState) =>
  state.prefecture.prefectureResponse;
